import LoginPage from "components/pages/LoginPage";

export default function CaptureFaceIDLogin(props) {
    return <LoginPage />
}